function getFeedbackRequestOneData(req, at) {
  const FeedbackRequest = {
    ...(at && { accountToken: at }),
    ...req,
  };

  return FeedbackRequest;
}

export default getFeedbackRequestOneData;
